import React from 'react';
import styled, { css, DefaultTheme } from 'styled-components';
import { MarginProps } from 'styled-system';

import { Margin } from 'src/packages/core';
import { hexToRGBA } from 'src/utils/hex-to-rgba';

import { NotificationType } from './Notification.types';

export const getNotificationStyles = (
  type: NotificationType,
  theme: DefaultTheme,
  withBorder: boolean
) => {
  switch (type) {
    case 'error':
      return css`
        border: ${withBorder ? `1px solid ${theme.colors.palette.red}` : 'none'};
        background: ${hexToRGBA(theme.colors.palette.red, 0.15)};
        color: ${theme.colors.text.primary};

        svg path {
          fill: ${theme.colors.palette.red};
        }
      `;
    case 'success':
      return css`
        border: ${withBorder ? `1px solid ${theme.colors.palette.green}` : 'none'};
        background: ${hexToRGBA(theme.colors.palette.green, 0.15)};
        color: ${theme.colors.text.primary};

        svg path {
          fill: ${theme.colors.palette.green};
        }
      `;
    case 'warning':
      return css`
        border: ${withBorder ? `1px solid ${theme.colors.palette.orange}` : 'none'};
        background: ${hexToRGBA(theme.colors.palette.orange, 0.15)};
        color: ${theme.colors.text.primary};

        svg path {
          fill: ${theme.colors.palette.orange};
        }
      `;
    case 'info':
      return css`
        border: ${withBorder ? `1px solid ${theme.colors.palette.blue}` : 'none'};
        background: ${hexToRGBA(theme.colors.palette.blue, 0.15)};
        color: ${theme.colors.text.primary};

        svg path {
          fill: ${theme.colors.palette.blue};
        }
      `;
  }
};

export const StyledNotification = styled((props) => <Margin {...props} />)<
  {
    width: string;
    notificationStyles: any;
  } & MarginProps
>`
  display: flex;
  border-radius: 6px;
  padding: 14px 16px;
  width: ${(props) => props.width};
  border: none;
  ${(props) => props.notificationStyles};
  direction: ltr;

  svg {
    margin-right: 8px;
    width: 24px;
    height: 24px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    padding: 12px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;
